import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { InvalidCustomField } from './shared'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { WithTooltip, tooltipTitleCss } from '../../design-system'
import { CsHelpCircledIcon } from '../../legacy-design-system/icons'

const missingFieldIconCss = css`
  color: ${theme.color.neutral60};
`

const tooltipContainerCss = css`
  max-width: 200px;
`

interface Props {
  readonly invalidCustomMetadataFields: InvalidCustomField[]
}

export function getAgentLabels(
  invalidCustomMetadataFields: InvalidCustomField[],
  validationType: string
) {
  return invalidCustomMetadataFields
    .filter((field) => field.validationType === validationType)
    .map((field) => field.id)
}

function getDescription(invalidFields: string[], missingFields: string[]) {
  const mrf = missingFields.join(', ')
  const vef = invalidFields.join(', ')
  if (invalidFields.length && missingFields.length) {
    return (
      <FormattedMessage
        id="detail_applicationMetadata_missingRequiredFields_validationErrorFields"
        values={{
          missingRequiredFields: <b>{mrf}</b>,
          validationErrorFields: <b>{vef}</b>,
          countMissing: missingFields.length,
          countValidation: invalidFields.length
        }}
      />
    )
  } else if (invalidFields.length) {
    return (
      <FormattedMessage
        id="detail_applicationMetadata_validationErrorFields"
        values={{
          validationErrorFields: <b>{vef}</b>,
          count: invalidFields.length
        }}
      />
    )
  } else {
    return (
      <FormattedMessage
        id="detail_applicationMetadata_missingRequiredFields"
        values={{
          missingRequiredFields: <b>{mrf}</b>,
          count: missingFields.length
        }}
      />
    )
  }
}

export function TooltipContent({ invalidCustomMetadataFields }: Props) {
  const invalidFields: string[] = getAgentLabels(
    invalidCustomMetadataFields,
    'invalid'
  )
  const missingFields: string[] = getAgentLabels(
    invalidCustomMetadataFields,
    'missing'
  )

  const title = {
    id: 'title_missingField',
    values: {
      count: missingFields.length + invalidFields.length
    }
  }

  return (
    <div className={tooltipContainerCss}>
      <FormattedMessage {...title}>
        {(title) => <div className={tooltipTitleCss}>{title}</div>}
      </FormattedMessage>

      {getDescription(invalidFields, missingFields)}
    </div>
  )
}

export function MissingFieldIndicator(props: Props) {
  return (
    <WithTooltip
      placement="bottom"
      renderTooltipContent={() => {
        return <TooltipContent {...props} />
      }}
      children={() => {
        return <CsHelpCircledIcon className={missingFieldIconCss} size="16" />
      }}
    />
  )
}
